import { render } from "./Notes15.vue?vue&type=template&id=713f7f7c&scoped=true"
import script from "./Notes15.vue?vue&type=script&lang=js"
export * from "./Notes15.vue?vue&type=script&lang=js"

import "./Notes15.vue?vue&type=style&index=0&id=713f7f7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713f7f7c"]])

export default __exports__